// extracted by mini-css-extract-plugin
export var resizer = "_gl-0";